// extracted by mini-css-extract-plugin
module.exports = {"rmsc-global":"CancelModal_rmsc-global__36cFV"};